import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Constraint } from '../interfaces/data';

@Injectable({
  providedIn: 'root'
})
export class ValidatorService {
  private validatorSubject: Subject<Constraint[]> = new Subject<Constraint[]>();
  private validatorForm!: Constraint[];

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() { }

  setValidators(validators: Constraint[]) {
    this.validatorSubject.next(validators);
    this.validatorForm = validators;
  }

  validators() {
    return this.validatorSubject.asObservable();
  }

  getValidatorForm() {
    return this.validatorForm;
  }
}
